module.exports = __webpack_public_path__ + "static/og-e3da2f0297153986055feb9e47399529.png";